import type { FC } from 'react';
import { Button } from '@components/ui/button';

interface FooterProps {
  applyButtonLabel: string;
  isApplyDisabled: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export const Footer: FC<FooterProps> = ({ onCancel, isApplyDisabled, applyButtonLabel, onSubmit }) => {
  'use memo';
  return (
    <div className="mt-1 flex items-center justify-end gap-3">
      <Button type="button" variant="outline" onClick={onCancel} className="px-5">
        Cancel
      </Button>
      <Button type="button" variant="primary" disabled={isApplyDisabled} onClick={onSubmit} className="px-5">
        {applyButtonLabel}
      </Button>
    </div>
  );
};
